export const dataHooks = {
  iconSmall: `fillbutton-icon-small`,
  iconMedium: `fillbutton-icon-medium`,
  button: `fillbutton`,
};

export const COLOR_ICON_LIGHT = '#ffffff';
export const COLOR_ICON_DARK = '#162d3d';
